import React from "react";
import { useTranslation } from "react-i18next";

import { HomeAwayScore } from "@gp/models";

export function HalfTimeScore({
	halfTimeScore,
	labelKey = "EVENT.DETAILS.HT",
}: {
	halfTimeScore: HomeAwayScore;
	labelKey?: string;
}) {
	const { t } = useTranslation();

	return (
		<div className="event__stats__item">
			<div className="event__stats__label">{t(labelKey)}</div>
			<div className="event__stats__result">
				<span>{halfTimeScore.home || 0}</span>
				<span> - </span>
				<span>{halfTimeScore.away || 0}</span>
			</div>
		</div>
	);
}
